import React from 'react';
import { contactInfo } from '../data/mock';
import { Phone, Mail, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          {/* Brand */}
          <div>
            <h3 className="heading-font text-3xl font-bold text-white mb-4">
              Elysian Evenings
            </h3>
            <p className="body-font text-gray-400 leading-relaxed">
              Designing unforgettable conference experiences through curated entertainment and seamless execution.
            </p>
          </div>

          {/* Quick Contact */}
          <div>
            <h4 className="body-font text-lg font-semibold text-white mb-4">
              Quick Contact
            </h4>
            <div className="space-y-3">
              <a 
                href={`tel:${contactInfo.phone}`}
                className="flex items-center gap-3 text-gray-400 hover:text-yellow-400 transition-colors"
              >
                <Phone size={18} className="gold-accent" />
                <span className="body-font">{contactInfo.phone}</span>
              </a>
              <a 
                href={`mailto:${contactInfo.emails[0]}`}
                className="flex items-center gap-3 text-gray-400 hover:text-yellow-400 transition-colors"
              >
                <Mail size={18} className="gold-accent" />
                <span className="body-font">{contactInfo.emails[0]}</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="body-font text-lg font-semibold text-white mb-4">
              Our Services
            </h4>
            <ul className="space-y-2 body-font text-gray-400">
              <li>Entertainment Management</li>
              <li>Theme Nights</li>
              <li>Medical Conferences</li>
              <li>Corporate Events</li>
              <li>Bollywood Experiences</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="body-font text-gray-500 text-sm">
            © {currentYear} Elysian Evenings. All rights reserved.
          </p>
          <p className="body-font text-gray-500 text-sm flex items-center gap-2">
            Crafted with <Heart className="gold-accent" size={16} fill="#D4AF37" /> for unforgettable moments
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
